import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Settings2, FileUp, ArrowUp, ArrowRight } from "lucide-react";
const orderPaths = [{
  title: "Configure a standard product",
  description: "Pick a product family above, choose size, material, color, and mounting, and request a quote. Best for standard legend plates, nameplates, tags, and schedules.",
  linkText: "Browse product families",
  linkUrl: "#product-families",
  icon: Settings2,
  linkIcon: ArrowUp
}, {
  title: "Upload a file for custom work",
  description: "Send a drawing, part list, or sample for a non-standard item. Evermark scopes material, mounting, and tolerance and quotes it.",
  linkText: "Custom engraving",
  linkUrl: "/CustomEngravingPage",
  icon: FileUp,
  linkIcon: ArrowRight
}];
export default function ConfigureOrUpload() {
  return;
}